import {FaFacebookF, FaInstagram,FaTwitter,FaLinkedin, FaDribbble} from '../assets/icons/vander'

import portfolio1 from '../assets/images/portfolio/01.jpg'
import portfolio2 from '../assets/images/portfolio/02.jpg'
import portfolio3 from '../assets/images/portfolio/03.jpg'
import portfolio4 from '../assets/images/portfolio/04.jpg'
import portfolio5 from '../assets/images/portfolio/05.jpg'
import portfolio6 from '../assets/images/portfolio/06.jpg'
import portfolio7 from '../assets/images/portfolio/07.jpg'
import portfolio8 from '../assets/images/portfolio/08.jpg'
import portfolio9 from '../assets/images/portfolio/09.jpg'
import portfolio10 from '../assets/images/portfolio/10.jpg'
import portfolio11 from '../assets/images/portfolio/11.jpg'
import portfolio12 from '../assets/images/portfolio/12.jpg'
import portfolio13 from '../assets/images/portfolio/13.jpg'
import portfolio14 from '../assets/images/portfolio/14.jpg'
import portfolio15 from '../assets/images/portfolio/15.jpg'
import portfolio16 from '../assets/images/portfolio/16.jpg'
import portfolio17 from '../assets/images/portfolio/17.jpg'
import portfolio18 from '../assets/images/portfolio/18.jpg'

import foto1 from '../assets/images/portfolio/OF_5.jpeg'
import foto2 from '../assets/images/portfolio/OF_41.jpeg'
import foto3 from '../assets/images/portfolio/OF_3.jpeg'
import foto4 from '../assets/images/portfolio/OF_4.jpeg'
import foto5 from '../assets/images/portfolio/EMT_1.jpeg'
import foto6 from '../assets/images/portfolio/EMT_2.jpeg'
import foto7 from '../assets/images/portfolio/EMT_3.jpeg'
import foto8 from '../assets/images/portfolio/DCS_1.jpeg'
import foto9 from '../assets/images/portfolio/DCS_2.jpeg'
import foto10 from '../assets/images/portfolio/DCS_3.jpeg'
import foto11 from '../assets/images/portfolio/RehaCom_1.jpeg'
import foto12 from '../assets/images/portfolio/RehaCom_2.jpeg'
import foto13 from '../assets/images/portfolio/RehaCom_3.jpeg'





export const portfolioData = [
    {
        id:1,
        image:portfolio1,
        title:'The Leaf and Letter',
        name:'Branding',
        category:'branding'
    },
    {
        id:2,
        image:portfolio2,
        title:'The Papers',
        name:'Designing',
        category:'designing'
    },
    {
        id:3,
        image:portfolio3,
        title:'The Headphones',
        name:'Photography',
        category:'photography'
    },
    {
        id:4,
        image:portfolio4,
        title:'The Projects',
        name:'Development',
        category:'development'
    },
    {
        id:5,
        image:portfolio5,
        title:'The Cup of Coffee',
        name:'Branding',
        category:'branding'
    },
    {
        id:6,
        image:portfolio6,
        title:'The Pen and Books',
        name:'Designing',
        category:'designing'
    },
    {
        id:7,
        image:portfolio7,
        title:'The Strawberry',
        name:'Photography',
        category:'photography'
    },
    {
        id:8,
        image:portfolio8,
        title:'The Leaf and Books',
        name:'Development',
        category:'development'
    },
    {
        id:9,
        image:portfolio9,
        title:'The Cactus Plant',
        name:'Branding',
        category:'branding'
    },
    {
        id:10,
        image:portfolio10,
        title:'The Yellow Bag',
        name:'Photography',
        category:'photography'
    },
    {
        id:11,
        image:portfolio11,
        title:'The Teapot Table',
        name:'Designing',
        category:'designing'
    },
    {
        id:12,
        image:portfolio12,
        title:'The Orange',
        name:'Development',
        category:'development'
    },
]
export const portfolioImg = [
    portfolio1,portfolio2,portfolio3,portfolio4,portfolio5,portfolio6,portfolio7,portfolio8,portfolio9,portfolio10,portfolio11,portfolio12,
]

export const masonaryData = [
    {
        id:1,
        image:foto1,
        title:'Recepción',
        name:'Oficina',
        category:'oficina',
        estilo:'esquina_superior_izquierda',
        reflejo:''
    },
    {
        id:2,
        image:foto2,
        title:'Lobby',
        name:'Oficina',
        category:'oficina',
        estilo:'esquina_inferior_izquierda',
        reflejo:''
    },
      {
        id:3,
        image:foto7,
        title:'DuoMAGxt',
        name:'Magnética Transcraneal',
        category:'magnetica',
        estilo:'',
        reflejo:'shadow'
    },
      {
        id:4,
        image:foto10,
        title:'NE neuroelectrics',
        name:'Eléctrica Transcraneal',
        category:'electrica',
        estilo:'',
        reflejo:'shadow'
    },
    
    {
        id:5,
        image:foto5,
        title:'DuoMAGxt',
        name:'Magnética Transcraneal',
        category:'magnetica',
        estilo:'',
        reflejo:'shadow'
    },

   {
        id:6,
        image:foto13,
        title:'RehaCom',
        name:'Terapia Cognitiva',
        category:'cognitiva',
        estilo:'',
        reflejo:'shadow'
    },
   
    {
        id:7,
        image:foto12,
        title:'RehaCom',
        name:'Terapia Cognitiva',
        category:'cognitiva',
        estilo:'',
        reflejo:'shadow'
    },
    {
        id:8,
        image:foto9,
        title:'NE neuroelectrics',
        name:'Eléctrica Transcraneal',
        category:'electrica',
        estilo:'',
        reflejo:'shadow'
    },
    {
        id:9,
        image:foto4,
        title:'Bienvenido',
        name:'Oficina',
        category:'oficina',
        estilo:'',
        reflejo:'shadow'
    }, 
    {
        id:10,
        image:foto11,
        title:'RehaCom',
        name:'Terapia Cognitiva',
        category:'cognitiva',
        estilo:'esquina_superior_derecha',
        reflejo:''
    },
        {
        id:11,
        image:foto6,
        title:'DuoMAGxt',
        name:'Magnética Transcraneal',
        category:'magnetica',
        estilo:'esquina_inferior_derecha',
        reflejo:''
    },
    
   
]

export const masonaryImg = [
   foto1, foto2, foto7, foto10, foto5, foto13, foto12, foto9, foto4 , foto11, foto6,
]

export const social = [
    FaFacebookF,FaInstagram,FaTwitter,FaLinkedin,FaDribbble
]